import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isItemsValidationConflictPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { itemsValidationConflictTitleSelector, itemsValidationConflictMessageSelector } from '../../../redux/cart/cart.selectors';
import { ItemsValidationConflictPopup as ItemsValidationConfPopupComponent } from './items-validation-conflict-popup';
const mapStateToProps = createStructuredSelector({
  open: isItemsValidationConflictPopupShownSelector,
  title: itemsValidationConflictTitleSelector,
  message: itemsValidationConflictMessageSelector
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hidePopup());
  }
});
export const ItemsValidationConflictPopup = connect(mapStateToProps, mapDispatchToProps)(ItemsValidationConfPopupComponent);